import { PropTypes } from 'prop-types';
import React from 'react';

const ClaimWizardProgress = ({ ariaLabel, currentStep, onStepClick, steps }) => (
  <nav className="claim-wizard-steps" aria-label={ariaLabel}>
    {steps.map((step, index) => {
      const complete = index < currentStep;
      const active = index === currentStep;
      return (
        <button
          type="button"
          key={step}
          className={`${active ? 'active' : ''}${complete ? ' complete' : ''}`}
          onClick={() => onStepClick(index)}
        >
          <span>{index + 1}</span>
          {step}
        </button>
      );
    })}
  </nav>
);

ClaimWizardProgress.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  onStepClick: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ClaimWizardProgress;
